import { LocalizedEnum, lt } from '@mews/framework';
import { Stack, Tag } from '@optimus-web/core';
import { RateGroupOptions } from '@mews-commander/data-access';
import { UnicodeEntity } from '@mews/enums';
import { Dash, DividerList, LabeledListItem, ContentSection } from '@mews-commander/ui';
import { TextKey } from '@mews-commander/enums';

const rateGroupOptions = {
    [RateGroupOptions.AutomaticDepositSettlement]: TextKey.RateGroupOptionsAutomaticTaxDeposit,
    [RateGroupOptions.CreateSettlementTask]: TextKey.RateGroupOptionsCreatePaymentTask,
};

interface Props {
    settlementMaximumTimeUnits?: number | null;
    settlementExtent: Array<'TimeUnits' | 'Products' | 'AdditionalExpenses'>;
    options: Array<'AutomaticDepositSettlement' | 'CreateSettlementTask'>;
    settlementCurrencyCode?: string;
    rightContent?: React.ReactNode;
}

export const SettlementConfigurationSection = ({
    settlementMaximumTimeUnits,
    settlementExtent,
    options,
    settlementCurrencyCode,
    rightContent,
}: Props) => (
    <ContentSection
        title={lt('RateGroupConfiguration')}
        description={lt('RateGroupConfigurationDescription')}
        rightContent={rightContent}
    >
        <DividerList>
            <LabeledListItem label={lt('PaymentMaximumTime')}>
                {settlementMaximumTimeUnits ?? UnicodeEntity.Dash}
            </LabeledListItem>
            <LabeledListItem label={lt('SettlementExtent')}>
                <Stack spacing="100">
                    {settlementExtent.map((extent) => (
                        <Tag key={extent} variant="basicSubtle" outline>
                            {/* @ts-expect-error error because we're decoupling these components from enums and using string literals */}
                            <LocalizedEnum prefix="SettlementExtent" value={extent} />
                        </Tag>
                    ))}
                </Stack>
            </LabeledListItem>
            <LabeledListItem label={lt('Options')}>
                <Stack spacing="100">
                    {options.length > 0 ? (
                        options.map((option) => (
                            <Tag key={option} variant="basicSubtle" outline>
                                {lt(rateGroupOptions[option])}
                            </Tag>
                        ))
                    ) : (
                        <Dash />
                    )}
                </Stack>
            </LabeledListItem>
            {settlementCurrencyCode ? (
                <LabeledListItem label={lt('Currency')}>
                    <Tag variant="basicSubtle" outline>
                        {settlementCurrencyCode}
                    </Tag>
                </LabeledListItem>
            ) : null}
        </DividerList>
    </ContentSection>
);
